<template>
  <ButtonDefault
    :button-name="$t('shooting.buttons.download.btnVhcReport')"
    :outlined="true"
    :loading="downloadLoading"
    @click="downloadReport"
  />
</template>

<script>
import api from '@/script/api'
import ButtonDefault from '@/components/common/atoms/ButtonDefault.vue'

export default {
  name: 'DownloadReport',
  components: {
    ButtonDefault
  },
  props: {
    shootingId: String,
    registration: String,
    date: String
  },
  data() {
    return {
      downloadLoading: false
    }
  },
  methods: {
    async downloadReport() {
      this.downloadLoading = true
      const ownerId = this.$route.params.ownerId
      const productId = this.$route.params.productId

      const response = await api.downloadAddendum(ownerId, productId, this.shootingId, this.registration, this.date)

      if (response === 'ERROR') {
        this.snackbarMessage(this.$t('api.commonError'), 'error')
      } else if (response === 'NO_PDF') {
        this.snackbarMessage(this.$t('api.noPdfFileFound'), 'info')
      }

      this.downloadLoading = false
    },
    snackbarMessage(message, color) {
      this.$store.commit('SET_SNACKBAR', { snack: message, color: color })
    }
  }
}
</script>
